<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header">
      <a id="TargetReisedaten"></a>
      <h3>
        <i class="icon-reisedaten"></i><span i18n>Reisedaten</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header card-header-detail" i18n>Reisedaten</div>
            <div class="card-body">

              <div class="row align-items-start">

                <div class="col-md-4">
                  <div class="mb-3">

                    <label for="reisedaten.aufenthaltszweckListe[0]" i18n [class.mandatory]="isMandatory('reisezweck1')">Zweck(e) der Reise:</label>
                    <span>
                      <select id="reisedaten.aufenthaltszweckListe[0]"
                              class="form-select form-select-sm mb-2"
                              [class.is-invalid]="errorClassRequired(form.controls['reisezweck1'])"
                              formControlName="reisezweck1"
                              [ngbPopover]="popover_reisedaten_aufenthaltszweckListe_0"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of reisezweckListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_reisedaten_aufenthaltszweckListe_0>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier den Zweck der Reise des/der Antragstellenden ein.</span>
                        </app-assistant>
                      </ng-template>
                    </span>

                    <span>
                      <select *ngIf="form.value.reisezweck1"
                              id="reisedaten.aufenthaltszweckListe[1]"
                              class="form-select form-select-sm mb-2"
                              formControlName="reisezweck2"
                              [ngbPopover]="popover_reisedaten_aufenthaltszweckListe_1"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of reisezweckListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_reisedaten_aufenthaltszweckListe_1>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier ggf. einen weiteren Reisezweck ein.</span>
                        </app-assistant>
                      </ng-template>
                    </span>

                    <span>
                      <select *ngIf="form.value.reisezweck2"
                              id="reisedaten.aufenthaltszweckListe[2]"
                              class="form-select form-select-sm mb-2"
                              formControlName="reisezweck3"
                              [ngbPopover]="popover_reisedaten_aufenthaltszweckListe_2"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of reisezweckListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_reisedaten_aufenthaltszweckListe_2>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier ggf. einen dritten Reisezweck ein.</span>
                        </app-assistant>
                      </ng-template>
                    </span>

                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="reisedaten.angegebenerReisezweck" [class.mandatory]="isMandatory('sonstigerReisezweck')" i18n>
                      Sonstiges (bitte nähere Angaben):</label>
                    <input id="reisedaten.angegebenerReisezweck"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('sonstigerReisezweck')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['sonstigerReisezweck'])"
                           formControlName="sonstigerReisezweck"
                           [ngbPopover]="popover_reisedaten_angegebenerReisezweck"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_reisedaten_angegebenerReisezweck>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier ggf. einen sonstigen Reisezweck ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="reisedaten.weitereInformationen" [class.mandatory]="isMandatory('weitereInformationen')" i18n
                    >Weitere Informationen zum Aufenthaltszweck:</label>
                    <input id="reisedaten.weitereInformationen"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('weitereInformationen')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['weitereInformationen'])"
                           formControlName="weitereInformationen"
                           [ngbPopover]="popover_reisedaten_weitereInformationen"
                           appSaveLastFocussed
                    >
                    <ng-template #popover_reisedaten_weitereInformationen>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte konkretisieren Sie Ihren geplanten Aufenthaltszweck näher.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

              </div>

              <div class="row align-items-start">

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="reisedaten.ersteinreiseStaat" [class.mandatory]="isMandatory('ersteinreiseStaat')" i18n>
                      Mitgliedstaat der ersten Einreise:</label>
                    <select id="reisedaten.ersteinreiseStaat"
                            class="form-select form-select-sm"
                            [class.is-invalid]="errorClassRequired(form.controls['ersteinreiseStaat'])"
                            formControlName="ersteinreiseStaat"
                            [ngbPopover]="popover_reisedaten_ersteinreiseStaat"
                            appSaveLastFocussed
                    >
                      <option value="" selected></option>
                      <option *ngFor="let listItem of schengenlandListItems"
                              value="{{ listItem.key }}">{{ listItem.value }}
                      </option>
                    </select>
                    <ng-template #popover_reisedaten_ersteinreiseStaat>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier ein, in welchen Mitgliedstaat der/die Antragstellende zuerst einreisen wird.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">

                    <label for="reisedaten.hauptzielListe[0]" i18n [class.mandatory]="isMandatory('zielStaat1')">Hauptreiseziel(e):</label>
                    <span>
                      <select id="reisedaten.hauptzielListe[0]"
                              class="form-select form-select-sm mb-2"
                              [class.is-invalid]="errorClassRequired(form.controls['zielStaat1'])"
                              formControlName="zielStaat1"
                              [ngbPopover]="popover_reisedaten_hauptzielListe_0"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of schengenlandListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_reisedaten_hauptzielListe_0>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier ein, welcher Mitgliedsstaat das Hauptreiseziel des/der Antragstellenden ist (Bestimmungsmitgliedstaat). Das Hauptreiseziel ist der Ort, an dem der/die Antragstellende die meiste Zeit zu verbringen beabsichtigt oder wohin ihn/sie der Hauptzweck der Reise führt.</span>
                        </app-assistant>
                      </ng-template>
                    </span>

                    <span>
                      <select *ngIf="form.value.zielStaat1"
                              id="reisedaten.hauptzielListe[1]"
                              class="form-select form-select-sm mb-2"
                              formControlName="zielStaat2"
                              [ngbPopover]="popover_reisedaten_hauptzielListe_1"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of schengenlandListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_reisedaten_hauptzielListe_1>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span
                            i18n>Bitte tragen Sie hier ggf. ein, welcher Mitgliedsstaat das zweite Hauptreiseziel des/der Antragstellenden ist.</span>
                        </app-assistant>
                      </ng-template>
                    </span>

                    <span>
                      <select *ngIf="form.value.zielStaat2"
                              id="reisedaten.hauptzielListe[2]"
                              class="form-select form-select-sm mb-2"
                              formControlName="zielStaat3"
                              [ngbPopover]="popover_reisedaten_hauptzielListe_2"
                              appSaveLastFocussed
                      >
                        <option value="">---</option>
                        <option *ngFor="let listItem of schengenlandListItems" value="{{ listItem.key }}">{{ listItem.value }}</option>
                      </select>
                      <ng-template #popover_reisedaten_hauptzielListe_2>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span
                            i18n>Bitte tragen Sie hier ggf. ein, welcher Mitgliedsstaat das dritte Hauptreiseziel des/der Antragstellenden ist.</span>
                        </app-assistant>
                      </ng-template>
                    </span>

                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="visumdaten.anzahlEinreisen" [class.mandatory]="isMandatory('anzahlEinreisen')" i18n>
                      Anzahl der beantragten Einreisen:</label>
                    <select id="visumdaten.anzahlEinreisen"
                            class="form-select form-select-sm"
                            [class.is-invalid]="errorClassRequired(form.controls['anzahlEinreisen'])"
                            formControlName="anzahlEinreisen"
                            [ngbPopover]="popover_visumdaten_anzahlEinreisen"
                            appSaveLastFocussed
                    >
                      <option value="" selected></option>
                      <option *ngFor="let listItem of anzahlEinreisenListItems"
                              value="{{ listItem.key }}">{{ listItem.value }}
                      </option>
                    </select>
                    <ng-template #popover_visumdaten_anzahlEinreisen>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier ein, für wie viele Einreisen in das Hoheitsgebiet der Mitgliedstaaten der/die Antragstellende das Visum beantragt.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

              </div>

              <div class="row">

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="visumdaten.gueltigkeit.von" i18n [class.mandatory]="isMandatory('ankunftsdatum')">
                      Geplantes Ankunftsdatum des ersten geplanten Aufenthalts im Schengen-Raum:</label>
                    <div class="input-group" *ngIf="presentationModeEnum.DEFAULT === appConfig.presentationMode">
                      <input angular-mydatepicker
                             id="visumdaten.gueltigkeit.von"
                             #ankunftsdatum="angular-mydatepicker"
                             [options]="datepickerOptions"
                             class="form-control form-control-sm w-50"
                             type="text"
                             [class.is-invalid]="errorClassRequired(form.controls['ankunftsdatum'])"
                             [attr.maxlength]="getMaxLength('ankunftsdatum')"
                             formControlName="ankunftsdatum"
                             [ngbPopover]="popover_visumdaten_gueltigkeit_von"
                             appSaveLastFocussed
                             (inputFieldChanged)="onDatePickerInputFieldChanged('ankunftsdatum', $event)"
                             (blur)="onDatePickerBlur('ankunftsdatum')"
                      />
                      <span class="input-group-text date-picker" (click)="ankunftsdatum.toggleCalendar()"><i class="icon-calendar"></i></span>
                    </div>
                    <div class="input-group" *ngIf="presentationModeEnum.AP2 === appConfig.presentationMode">
                      <input type="text"
                             class="form-control form-control-sm w-50"
                             value="{{dateFormatter.getFormattedDatePickerValue(form.value.ankunftsdatum)}}"
                             disabled
                      />
                      <span class="input-group-text date-picker"><i class="icon-calendar"></i></span>
                    </div>
                    <ng-template #popover_visumdaten_gueltigkeit_von>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier das Datum ein, an dem Sie planen im Schengen-Raum anzukommen.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="visumdaten.gueltigkeit.bisGenau.value" i18n [class.mandatory]="isMandatory('abreisedatum')">
                      Geplantes Abreisedatum aus dem Schengen-Raum nach dem ersten geplanten Aufenthalt:</label>
                    <div class="input-group" *ngIf="presentationModeEnum.DEFAULT === appConfig.presentationMode">
                      <input angular-mydatepicker
                             id="visumdaten.gueltigkeit.bisGenau.value"
                             #abreisedatum="angular-mydatepicker"
                             [options]="datepickerOptions"
                             class="form-control form-control-sm w-50"
                             type="text"
                             [class.is-invalid]="errorClassRequired(form.controls['abreisedatum'])"
                             [attr.maxlength]="getMaxLength('abreisedatum')"
                             formControlName="abreisedatum"
                             [ngbPopover]="popover_visumdaten_gueltigkeit_bisGenau_value"
                             appSaveLastFocussed
                             (inputFieldChanged)="onDatePickerInputFieldChanged('abreisedatum', $event)"
                             (blur)="onDatePickerBlur('abreisedatum')"
                      />
                      <span class="input-group-text date-picker" (click)="abreisedatum.toggleCalendar()"><i class="icon-calendar"></i></span>
                    </div>
                    <div class="input-group" *ngIf="presentationModeEnum.AP2 === appConfig.presentationMode">
                      <input type="text"
                             class="form-control form-control-sm w-50"
                             value="{{dateFormatter.getFormattedDatePickerValue(form.value.abreisedatum)}}"
                             disabled
                      />
                      <span class="input-group-text date-picker"><i class="icon-calendar"></i></span>
                    </div>
                    <ng-template #popover_visumdaten_gueltigkeit_bisGenau_value>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier das Datum ein, an dem Sie planen den Schengen-Raum zu verlassen. Die maximale Aufenthaltsdauer im Schengen-Raum beträgt 90 Tage in einem Zeitraum von 180 Tagen. Der Tag der Einreise und der Tag der Ausreise zählen als Aufenthaltstage.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <app-einreisegenehmigung formControlName="einreisegenehmigung"></app-einreisegenehmigung>
        </div>
      </div>
    </div>


  </div>
</div>
